<template>
  <div :class="$style.wrapper">
    <div :class="$style.avatar">{{ initials }}</div>

    <h1 :class="$style.title">Заполните данные о себе</h1>
    <p :class="$style.subtitle">
      Это необходимо для продолжения работы на платформе
    </p>

    <div :class="$style.field">
      <label :class="$style.label">Login</label>
      <input
        :class="[
          $style.input,
          loginTouched && !loginValid && $style.inputError,
        ]"
        type="text"
        v-model.trim="login"
        placeholder="maksim"
        @blur="loginTouched = true"
        @input="updateMB"
      />
    </div>

    <div :class="$style.field">
      <label :class="$style.label">Tel</label>
      <input
        ref="tel"
        :class="[
          $style.input,
          phoneTouched && !phoneValid && $style.inputError,
          isPhonePlaceholder && $style.inputPlaceholder,
        ]"
        type="tel"
        inputmode="tel"
        autocomplete="tel"
        placeholder="+7 (___) ___-__-__"
        @blur="onPhoneBlur"
      />
      <div
        v-if="phoneTouched && !phoneValid && phone.length"
        :class="$style.error"
      >
        Введите номер в формате РФ
      </div>
    </div>

    <div :class="$style.field">
      <label :class="$style.label">Email</label>
      <input
        :class="[
          $style.input,
          emailTouched && !emailValid && $style.inputError,
        ]"
        type="email"
        v-model.trim="email"
        placeholder="maksim@example.com"
        autocomplete="email"
        inputmode="email"
        @blur="emailTouched = true"
        @input="updateMB"
      />
      <div v-if="emailTouched && !emailValid" :class="$style.error">
        Неверный формат email
      </div>
      <div
        v-else-if="emailTouched && emailValid && !emailRuZone"
        :class="$style.error"
      >
        Доступны только домены .ru, .su и .рф
      </div>
    </div>
  </div>
</template>

<script>
import IMask from "imask"

import { EMAIL_ZONE_MESSAGE, isRuZoneEmail } from "@/utils/emailZone"

export default {
  name: "FillingData",
  data() {
    return {
      login: "",
      email: "",
      phone: "+79231234252",
      phoneValid: false,
      loginTouched: false,
      emailTouched: false,
      phoneTouched: false,
      mask: null,
      mbHandler: null,
      phoneInputValue: "",
    }
  },
  computed: {
    initials() {
      const s = (this.login || this.email || "S").trim()
      return s ? s[0].toUpperCase() : "S"
    },
    loginValid() {
      return /^[a-zA-Z0-9._-]{3,20}$/.test(this.login || "")
    },
    emailValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(this.email || "")
    },
    emailRuZone() {
      return isRuZoneEmail(this.email)
    },
    allValid() {
      return this.loginValid && this.emailValid && this.phoneValid
    },
    isPhonePlaceholder() {
      if (!this.phoneInputValue) return true
      // Проверяем, есть ли хотя бы одна введенная цифра (после "+7 ")
      // Убираем все нецифровые символы и проверяем длину
      const digitsOnly = this.phoneInputValue.replace(/\D/g, "")
      // Если есть хотя бы одна цифра после "+7" (то есть длина > 1), делаем черный цвет
      return digitsOnly.length <= 1
    },
  },
  mounted() {
    this.mask = IMask(this.$refs.tel, {
      mask: "+{7} (000) 000-00-00",
      lazy: false,
      overwrite: true,
      autofix: true,
      placeholderChar: "_",
    })
    this.mask.on("accept", () => {
      this.phone = this.$refs.tel.value
      this.phoneInputValue = this.$refs.tel.value
      this.phoneValid = this.mask.masked.isComplete
      this.updateMB()
    })
    this.mask.on("complete", () => {
      this.phone = this.$refs.tel.value
      this.phoneInputValue = this.$refs.tel.value
      this.phoneValid = true
      this.updateMB()
    })
    if (!this.$refs.tel.value) {
      this.$refs.tel.value = "+7 "
      this.phoneInputValue = "+7 "
    } else {
      this.phoneInputValue = this.$refs.tel.value
    }

    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    if (mb) {
      mb.setText("Далее")
      mb.show()
      this.mbHandler = async () => {
        if (!this.allValid) return
        if (!this.emailRuZone) {
          this.showEmailZonePopup()
          return
        }
        const payload = {
          login: this.login,
          email: this.email,
          phone: this.phone,
        }
        try {
          const response = await this.$store.dispatch("registerStart", payload)
          if (response && response.status === 200) {
            this.$router.push({
              path: "/check-email",
              state: { payload },
            })
          }
        } catch (error) {
          console.error("Ошибка регистрации:", error)
          console.error("Статус:", error.response?.status)
          console.error("Данные:", error.response?.data)

          const tg = window.Telegram?.WebApp

          // Обработка ошибки 409 - email уже существует
          if (
            error.response?.status === 409 &&
            (error.response?.data?.detail === "This user email exist." ||
              error.response?.data?.detail?.includes("email exist"))
          ) {
            if (tg?.showPopup) {
              tg.showPopup({
                title: "Ошибка",
                message: "Такой email уже существует",
                buttons: [{ type: "close", text: "Ок" }],
              })
            } else {
              window.alert("Такой email уже существует")
            }
          } else if (
            error.response?.status === 409 &&
            (error.response?.data?.detail === "This user login exist." ||
              error.response?.data?.detail?.includes("login exist"))
          ) {
            // Обработка ошибки 409 - логин уже существует
            if (tg?.showPopup) {
              tg.showPopup({
                title: "Ошибка",
                message: "Такой логин уже существует",
                buttons: [{ type: "close", text: "Ок" }],
              })
            } else {
              window.alert("Такой логин уже существует")
            }
          } else {
            // Обработка других ошибок
            const errorMessage =
              error.response?.data?.detail ||
              error.response?.data?.message ||
              error.message ||
              "Произошла ошибка при регистрации"
            if (tg?.showPopup) {
              tg.showPopup({
                title: "Ошибка",
                message: errorMessage,
                buttons: [{ type: "close", text: "Ок" }],
              })
            } else {
              window.alert(errorMessage)
            }
          }
        }
      }
      mb.onClick(this.mbHandler)
      this.updateMB()
    }
  },
  beforeUnmount() {
    this.mask && this.mask.destroy()
    const mb = window.Telegram?.WebApp?.MainButton
    if (mb && this.mbHandler) mb.offClick(this.mbHandler)
  },
  methods: {
    showEmailZonePopup() {
      const tg = window.Telegram?.WebApp
      if (tg?.showPopup) {
        tg.showPopup({
          title: "Внимание",
          message: EMAIL_ZONE_MESSAGE,
          buttons: [{ type: "close", text: "Понятно" }],
        })
      } else {
        window.alert(EMAIL_ZONE_MESSAGE)
      }
    },
    onPhoneBlur() {
      this.phoneTouched = true
      this.updateMB()
    },
    updateMB() {
      const mb = window.Telegram?.WebApp?.MainButton
      if (!mb) return
      mb.setText("Далее")
      if (this.allValid) {
        mb.textColor = "#ffffff"
        mb.color = "#eb5a0a"
        mb.enable()
      } else {
        mb.textColor = "#B9B9BB"
        mb.color = "#E8E8EA"
        mb.enable()
      }
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  display: grid;
  justify-items: center;
  padding: 1rem;
}

.avatar {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background: #111;
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 3rem;
  font-weight: 600;
  margin: 1.5rem 0 0 0;
}

.title {
  text-align: center;
  font-size: 1.5rem;
  line-height: 1.2;
  font-weight: 600;
  margin: 1rem 0 0 0;
}

.subtitle {
  text-align: center;
  color: #9b9ba1;
  font-size: 1rem;
  line-height: 1.4;
  max-width: 18rem;
  margin: 0.5rem 0 1.875rem 0;
}

.field {
  width: 100%;
  display: grid;
  gap: 0.25rem;
  margin: 0 0 1rem 0;
}

.label {
  color: #8f8f94;
  font-size: 0.875rem;
  margin: 0 0 0 1rem;
}

.input {
  border-radius: 0.625rem;
  border: 1px solid #f0f0f2;
  background: #f6f6f7;
  padding: 0.625rem 1rem;
  font-size: 1rem;
  outline: none;
  caret-color: #000000;
  color: #161616;
  transition: border 0.2s, box-shadow 0.2s;
}

.input::placeholder {
  color: #16161674;
}

.inputPlaceholder {
  color: #8f8f94;
}

.inputError {
  border-color: #ff6b6b;
}

.error {
  color: #ff3b30;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
</style>
